export function deepCopyOdds(odds) {
    const newOdds = [];
    for (let i = 0; i < odds.length; i++) {
        const odd = odds[i];
        // Deep copy odd
		let newOdd = {
            id: odd.id,
            desc: odd.desc,
            ranking: odd.ranking,
            value: odd.value,
            tooltip: odd.tooltip,
            tooltipByHandicap: odd.tooltipByHandicap,
            betId: odd.betId,
            aliasListDefault: odd.aliasListDefault,
            aliasByHandicap: odd.aliasByHandicap,
            aliasBySystemCode: odd.aliasBySystemCode,
            aliasHandicapBySystemCode: odd.aliasHandicapBySystemCode
        };
		if (odd.aliasByHandicap != null) {
			newOdd.aliasByHandicap = {};
			for (let kh in odd.aliasByHandicap) {
				newOdd.aliasByHandicap[kh] = odd.aliasByHandicap[kh];
			}
		}
		newOdds.push(newOdd);
    }
    return newOdds;
}
